import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../environments/environment";
import { FilterObject } from "../interfaces/filter-object.interface";
import {
  PaginatedResponse,
  Pagination,
} from "../interfaces/pagination.interface";
import { TeamMember } from "../interfaces/team-member.interface";
import { UtilService } from "./util.service";

@Injectable({
  providedIn: "root",
})
export class TeamManagementService {
  constructor(
    private http: HttpClient,
    private utilService: UtilService,
  ) {}

  getTeamMembers(
    pagination: Pagination,
    filterObject?: FilterObject,
  ): Observable<PaginatedResponse<TeamMember>> {
    let obj = filterObject ? { ...pagination, ...filterObject } : pagination;
    obj = { ...obj, ...{ includeRoles: true } };
    const params = this.utilService.objectToHttpParams(obj);
    return this.http.get<PaginatedResponse<TeamMember>>(
      `${environment.API_URL}users`,
      {
        params,
      },
    );
  }

  getTeamMember(id: string): Observable<TeamMember> {
    return this.http.get<TeamMember>(`${environment.API_URL}users/${id}`);
  }

  addNewTeamMember(member: TeamMember): Observable<TeamMember> {
    return this.http.post<TeamMember>(`${environment.API_URL}users`, member);
  }

  editTeamMember(member: TeamMember): Observable<TeamMember> {
    return this.http.put<TeamMember>(
      `${environment.API_URL}users/${member.id}`,
      member,
    );
  }

  removeTeamMember(member: TeamMember): Observable<TeamMember> {
    return this.http.delete<TeamMember>(
      `${environment.API_URL}users/${member.id}`,
    );
  }

  assignTeamMemberRoles(id: string, roles: string[]): Observable<any> {
    return this.http.post<any>(`${environment.API_URL}users/roles/assign`, {
      userId: id,
      roleNames: roles,
    });
  }

  unAssignTeamMemberRoles(id: string, roles: string[]): Observable<any> {
    return this.http.delete<any>(`${environment.API_URL}users/roles/remove`, {
      body: {
        userId: id,
        roleNames: roles,
      },
    });
  }
}
